import { VStack } from "@chakra-ui/react";
import React from "react";

export const AddIcon = ({fill="#000"}) => {
  return (
    <VStack pb="5" pt="5">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
        viewBox="0 0 32 32"
        width="20px"
        height="20px"
      >
        <path d="M 15 5 L 15 15 L 5 15 L 5 17 L 15 17 L 15 27 L 17 27 L 17 17 L 27 17 L 27 15 L 17 15 L 17 5 Z" />
      </svg>
    </VStack>
  );
};
